<script setup lang="ts">
  const { t } = useI18n()

  export interface FooterProps {
    title?: string
    footerPosition?: 'absolute' | 'static' | 'fixed'
  }

  withDefaults(defineProps<FooterProps>(), {
    title: '',
    footerPosition: 'static',
  })

  const year = new Date().getFullYear()

  const siteSettingsStore = useSiteSettingsStore()
  const { data: siteSettings } = storeToRefs(siteSettingsStore)
</script>
<template>
  <footer
    id="footer"
    data-testid="footer"
    :class="[
      footerPosition,
      'bg-background-default',
      'hidden lg:flex bottom-0 right-0 w-full min-h-10 flex-row flex-nowrap items-center justify-end gap-[27px] pr-[10px] text-right text-[13px] leading-10 z-20',
    ]"
  >
    <SettingsButton v-if="siteSettings.userSettings?.position === 'footer'" />
    <a v-if="title === 'OneNews'" href="/contact" target="_blank">
      <Typography
        color="text-content-secondary"
        variant="text-[13px]"
        class="visited:no-underline hover:underline"
      >
        {{ t('Contact Us') }}
      </Typography>
    </a>
    <a href="/privacy-policy" target="_blank">
      <Typography
        color="text-content-secondary"
        variant="text-[13px]"
        class="visited:no-underline hover:underline"
      >
        {{ t('Privacy Policy') }}
      </Typography>
    </a>
    <a href="/terms" target="_blank">
      <Typography
        color="text-content-secondary"
        variant="text-[13px]"
        class="visited:no-underline hover:underline"
      >
        {{ t('Terms of Use') }}
      </Typography>
    </a>
    <span class="text-content-secondary">© {{ year }} {{ title }}</span>
  </footer>
</template>
